import axios from 'axios'

// state
export const state = {
  isAvatarsLoading: false,
  avatars: [],
}

// getters
export const getters = {
}
// mutations
export const mutations = {
  fetchAvatarsStart(state) {
    state.isAvatarsLoading = true
  },
  fetchAvatarsSuccess(state, { avatars }) {
    state.isAvatarsLoading = false
    state.avatars = avatars
  },
  fetchAvatarsFailed(state) {
    state.isAvatarsLoading = false
  },
}
// actions
export const actions = {
  async fetchAllAvatars({ commit }) {
    try {
      commit('fetchAvatarsStart')
      const avatars = await axios.get('profile/allAvatars')
      commit('fetchAvatarsSuccess', avatars)
    } catch (err) {
      commit('fetchAvatarsFailed')
    }
    return false
  },
  async changeAvatar({ commit, dispatch }, { avatarId }) {
    const status = await axios.post('profile/changeAvatar', {
      avatarId,
    })
    commit('auth/changeUserAvatar', { avatar: status.avatar }, { root: true })
    return status
  },
}
